import { Page } from '@roc/feature-app-core';
import { Route } from 'react-router';
import { BalanceSheetReportDashboard } from '../components/balanceSheetReport/balanceSheetReportDashboard';


export const getBalanceSheetReportRoutesConfig = (
  basePath: string,
  baseUrl: string,
) => {
  return {
    balanceSheetReportDashboard: {
      path: `${basePath}/trades/balance-sheet-report`,
      url: `${baseUrl}/trades/balance-sheet-report`,
      documentTitle: 'Balance Sheet Report',
    },
  };
};

export const getBalanceSheetReportRoutes = (basePath: string, baseUrl: string) => {
  const config = getBalanceSheetReportRoutesConfig(basePath, baseUrl);

  return {
    balanceSheetReportDashboard: (
      <Route exact path={config.balanceSheetReportDashboard.path}>
        <Page routeDefinition={config.balanceSheetReportDashboard}>
          <BalanceSheetReportDashboard />
        </Page>
      </Route>
    ),
  };
};
